module.exports = __webpack_public_path__ + "img/ExitusUX_Pics.6336e0a8.png";